import React from 'react';
import { Heading } from '@americanexpress/dls-react';

const NuiteeSearchPage = () => (
  <Heading level={1} variant="sans-xlarge-book">Nuitee Search</Heading>
);

export default NuiteeSearchPage;
